module.exports = __webpack_public_path__ + "img/round3-variation1.94101632.gif";